import { defineComponent, computed } from "vue";
import Card from "./component-library71.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "card-group",
  props: {
    items: null,
    startWithShortItem: { type: Boolean, default: false }
  },
  setup(__props, { expose }) {
    const props = __props;
    const filteredAndOrderedItems = computed(() => {
      if (!props.items)
        return [];
      return props.items.filter((item) => item !== null).sort((a, b) => (a.position || 0) - (b.position || 0));
    });
    const itemsWithType = computed(() => {
      let counter = 0;
      return filteredAndOrderedItems.value.map((item) => {
        const newItem = { ...item };
        if (newItem.typeComponent === "full" || newItem.typeComponent) {
          return newItem;
        }
        let moduloOrderItems = counter % 4 === 1 || counter % 4 === 2;
        if (props.startWithShortItem) {
          moduloOrderItems = !moduloOrderItems;
        }
        newItem.typeComponent = moduloOrderItems ? "short" : "long";
        counter += 1;
        return newItem;
      });
    });
    expose({ filteredAndOrderedItems, itemsWithType });
    return { __sfc: true, props, filteredAndOrderedItems, itemsWithType, Card };
  }
});
export {
  _sfc_main as default
};
